import { Flex } from "@portal/BaseComponents/Flex/Flex";
import { ImageComponent } from "@portal/BaseComponents/Image/AntImage";
import { Style } from "@portal/lib/style/style";

export const StyledImage = Style(ImageComponent, {
  "&.ant-image-img": {
    width: "60px",
    aspectRatio: "1/1",
    objectFit: "contain",
  },
});

export const LoginFormWrapper = Style(Flex, {
  backgroundColor: "var(--gray-1)",
  boxShadow: "var(--shadow-4)",
  borderRadius: "12px",
  width: "440px",
  overflow: "hidden",
  minHeight: "680px",
});
